// Image manifest data - generated by optimize-images.js
export const imageManifest = {
  "images": {
    "Harvester1.JPG": {
      "original": {
        "size": 2354006,
        "sizeMB": "2.24"
      },
      "blurDataURL": "data:image/webp;base64,UklGRlIAAABXRUJQVlA4IEYAAACQAwCdASoUAAsAPzmGulOvKSWisAgB4CcJYgCdACHwMX0iqPQAAN1tYvzGTSetD+B+R6/GKdeAJztKOcdqRdQRjay5wAAA",
      "srcsets": {
        "webp": "/assets/optimized/Harvester1-640w.webp 640w, /assets/optimized/Harvester1-1024w.webp 1024w, /assets/optimized/Harvester1-1920w.webp 1920w, /assets/optimized/Harvester1-2560w.webp 2560w",
        "jpg": "/assets/optimized/Harvester1-640w.jpg 640w, /assets/optimized/Harvester1-1024w.jpg 1024w, /assets/optimized/Harvester1-1920w.jpg 1920w, /assets/optimized/Harvester1-2560w.jpg 2560w"
      }
    },
    "mountains-1.png": {
      "original": {
        "size": 7407080,
        "sizeMB": "7.06"
      },
      "blurDataURL": "data:image/webp;base64,UklGRlgAAABXRUJQVlA4IEwAAABwAwCdASoUAAkAPzmGu1QvKSYjMAgB4CcJQBOgApMC810SsYAA/p2tx61rU2x9jMqOjPB9OHbh9IizvU3F9HrnN2DeJcfZRM9kzAAA",
      "srcsets": {
        "webp": "/assets/optimized/mountains-1-640w.webp 640w, /assets/optimized/mountains-1-1024w.webp 1024w, /assets/optimized/mountains-1-1920w.webp 1920w, /assets/optimized/mountains-1-2560w.webp 2560w",
        "jpg": "/assets/optimized/mountains-1-640w.jpg 640w, /assets/optimized/mountains-1-1024w.jpg 1024w, /assets/optimized/mountains-1-1920w.jpg 1920w, /assets/optimized/mountains-1-2560w.jpg 2560w"
      }
    },
    "mountains-2.png": {
      "original": {
        "size": 8242145,
        "sizeMB": "7.86"
      },
      "blurDataURL": "data:image/webp;base64,UklGRmAAAABXRUJQVlA4IFQAAACwAwCdASoUAAkAPzmGulQvKSWjMAgB4CcJYgCdABehXHGiQG9GAACrd9bpdw+f0NLor8hwluCa0p+GPNPWiWkNjUPMMggBLMjQDb4gRIviBBngAAA=",
      "srcsets": {
        "webp": "/assets/optimized/mountains-2-640w.webp 640w, /assets/optimized/mountains-2-1024w.webp 1024w, /assets/optimized/mountains-2-1920w.webp 1920w, /assets/optimized/mountains-2-2560w.webp 2560w",
        "jpg": "/assets/optimized/mountains-2-640w.jpg 640w, /assets/optimized/mountains-2-1024w.jpg 1024w, /assets/optimized/mountains-2-1920w.jpg 1920w, /assets/optimized/mountains-2-2560w.jpg 2560w"
      }
    },
    "mountain-curve.png": {
      "original": {
        "size": 9972840,
        "sizeMB": "9.51"
      },
      "blurDataURL": "data:image/webp;base64,UklGRlgAAABXRUJQVlA4IEwAAADQAwCdASoUAAkAPzmGulOvKSWisAgB4CcJYwDCgCPU1JV58L28L4AA/h1T8Bhyttl6MG6oM3zchFoHz8n125ej0k0xh2HSdJsGQAAA",
      "srcsets": {
        "webp": "/assets/optimized/mountain-curve-640w.webp 640w, /assets/optimized/mountain-curve-1024w.webp 1024w, /assets/optimized/mountain-curve-1920w.webp 1920w, /assets/optimized/mountain-curve-2560w.webp 2560w",
        "jpg": "/assets/optimized/mountain-curve-640w.jpg 640w, /assets/optimized/mountain-curve-1024w.jpg 1024w, /assets/optimized/mountain-curve-1920w.jpg 1920w, /assets/optimized/mountain-curve-2560w.jpg 2560w"
      }
    }
  }
} as const;

export type ImageManifest = typeof imageManifest;